"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.RequiredIntermediateFieldIterable = exports.LimitType = exports.LimitTypeIterable = exports.LimitValueType = exports.LimitValueTypeIterable = void 0;
// FinancialCovenant main content (non-namespace exports)
const _imports_1 = require("../_imports");
const AthenaConfig = __importStar(require("../AthenaConfig"));
const CommonIntermediateField = __importStar(require("../CommonIntermediateField"));
const CommonPostgresQuery = __importStar(require("../CommonPostgresQuery"));
const GlobalRecurringDate = __importStar(require("../GlobalRecurringDate"));
exports.LimitValueTypeIterable = ['currency', 'ratio', 'percentage'];
exports.LimitValueType = {
    currency: 'currency',
    ratio: 'ratio',
    percentage: 'percentage',
};
exports.LimitTypeIterable = ['min', 'max'];
exports.LimitType = {
    Min: 'min',
    Max: 'max',
};
/**
 * *** INTERMEDIATE FIELDS ***
 */
exports.RequiredIntermediateFieldIterable = [
    'triggerDate',
    'financialCovenantReportingDate',
    'financialCovenantValue',
    'financialCovenantResult',
];
/**
 * *** CONFIG ***
 */
exports.ConfigSchema = _imports_1.z.object({
    triggerDates: _imports_1.RecurringDate.ConfigSchema,
    globalRecurringDateConfigs: _imports_1.z.array(GlobalRecurringDate.ConfigSchema),
    athenaQueries: _imports_1.z.array(AthenaConfig.QuerySchema),
    athenaRecurringQueries: _imports_1.z.array(AthenaConfig.RecurringQuerySchema),
    postgresQueries: _imports_1.z.array(CommonPostgresQuery.FinancialCovenantPostgresQuerySchema),
    intermediateFields: _imports_1.z.array(CommonIntermediateField.IntermediateFieldSchema),
});
//# sourceMappingURL=FinancialCovenant.js.map